import { IOrganization, IPolicySet, IPolicyVersion } from '@tymely/atoms';
import { usePolicyVersionsQuery } from '@tymely/services';
import maxBy from 'lodash/maxBy';
import { useCallback, useState } from 'react';
import usePolicyParams from '@tymely/pages/GraphPolicyEditor/hooks/usePolicyParams';

export const usePolicyVersions = (orgId: IOrganization['id'], policySetId: IPolicySet['id'], enabled = true) => {
    const [selectedVersion, setSelectedVersion] = useState<IPolicyVersion | undefined>();
    const policyVersionsQuery = usePolicyVersionsQuery(orgId, policySetId, enabled);
    const { organizationId, intentId, navigate: navigateToPolicy } = usePolicyParams();

    const latestVersion = maxBy(policyVersionsQuery.data ?? [], (version) => version.created_at);

    const selectVersion = useCallback(
        (version?: IPolicyVersion) => {
            setSelectedVersion(version);

            if (version) {
                navigateToPolicy({
                    organizationId,
                    intentId,
                    versionId: version.id === latestVersion?.id ? undefined : version.id,
                });
            }
        },
        [intentId, latestVersion, navigateToPolicy, organizationId],
    );

    return { ...policyVersionsQuery, selectedVersion, selectVersion, latestVersion };
};
